import * as React from 'react';
import { IconButton } from '@ane/ui-components';
import { OptionsMenu } from '@ane/ui-components/lib/components/OptionsMenu';
import { ResizeGroup } from '@ane/ui-components/lib/components/ResizeGroup';
export const ResizeGroupAs = ({ ariaLabelForGroup, data, onRenderData }) => {
    const buttonData = {
        primaryItems: [...(data !== null && data !== void 0 ? data : [])],
        overflowItems: [],
    };
    const onReduceData = (currentData) => {
        var _a;
        const { primaryItems, overflowItems } = currentData;
        if (((_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0) > 0 && primaryItems.length > 0) {
            const movedItem = primaryItems[primaryItems.length - 1];
            const newPrimaryItems = primaryItems.slice(0, primaryItems.length - 1);
            const newOverflowItems = [movedItem, ...overflowItems];
            return { primaryItems: newPrimaryItems, overflowItems: newOverflowItems };
        }
        return undefined;
    };
    const onGrowData = (currentData) => {
        var _a;
        const { primaryItems, overflowItems } = currentData;
        if (((_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0) > 0 && overflowItems.length > 0) {
            const movedItem = overflowItems[0];
            const newPrimaryItems = [...primaryItems, movedItem];
            const newOverflowItems = overflowItems.slice(1);
            return { primaryItems: newPrimaryItems, overflowItems: newOverflowItems };
        }
        return undefined;
    };
    const onRenderItem = (item) => {
        return React.createElement(IconButton, Object.assign({}, item));
    };
    const onRenderOverflowButton = (overflowItems = []) => {
        return (React.createElement(OptionsMenu, { ariaLabel: `More options for ${ariaLabelForGroup}`, title: `More options for ${ariaLabelForGroup}`, menuIconProps: { iconName: 'More' }, menuProps: { items: overflowItems } }));
    };
    return (React.createElement(ResizeGroup, { data: buttonData, onReduceData: onReduceData, onGrowData: onGrowData, onRenderData: (data) => onRenderData(data, onRenderItem, onRenderOverflowButton) }));
};

//# sourceMappingURL=ResizeGroupAs.js.map
